import React from 'react';

interface ProcessStepProps {
  number: number;
  title: string;
  description: string;
  isActive?: boolean;
  isCompleted?: boolean;
  icon: React.ReactNode;
  showConnectorLines?: boolean;
}

export function ProcessStep({ 
  number, 
  title, 
  description, 
  isCompleted = false,
  icon,
  showConnectorLines = true
}: ProcessStepProps) {
  return (
    <div className="relative">
      {/* Connector line (except for last step) */}
      {showConnectorLines && number < 4 && (
        <div
          className={`absolute top-12 left-1/2 w-full h-0.5 ${
            isCompleted
              ? 'bg-primary-600 dark:bg-gradient-to-r dark:from-purple-600 dark:to-blue-500'
              : 'bg-neutral-200 dark:bg-white/10'
          } hidden lg:block`}
          style={{ transform: 'translateX(50%)' }}
        />
      )}
      
      <div className="relative flex flex-col items-center text-center">
        {/* Step number circle */}
        <div
          className={`
            relative z-10 flex items-center justify-center w-24 h-24 rounded-full
            transition-all duration-300 transform hover:scale-110
            ${isCompleted
              ? 'bg-primary-600 dark:bg-gradient-to-r dark:from-purple-600 dark:to-blue-500 text-white shadow-lg shadow-primary-600/30 dark:shadow-purple-500/30'
              : 'bg-white dark:bg-gray-800 text-primary-600 dark:text-primary-400 border-4 border-primary-600 dark:border-primary-500 shadow-md'
            }
          `}
        >
          {isCompleted ? (
            <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <div className="flex flex-col items-center">
              {icon}
            </div>
          )}
        </div>
        
        {/* Step content */}
        <h3 className="mt-4 text-xl font-bold text-[rgb(var(--foreground))] dark:text-white">{title}</h3>
        <p className="mt-2 text-lg text-[rgb(var(--foreground-muted))] dark:text-blue-100/80 max-w-xs">{description}</p>
      </div>
    </div>
  );
}